import { Injectable } from "@angular/core";
import { environment } from "./../../environments/environment";

@Injectable()
export class Configurations {
  /* CONST */

  get raggioRicerca(): number {
    return 20;
  }

  /* URLS WEB API */
  //TODO

  static local: boolean = true;
  static debug: boolean = false;
  static published: boolean = false;
  public static currentVersionCod: string = "0";

  static subfolderTaxonomyTipo: number = 1;
  static webApiDriverTipo: number = 1;
  //url base
  //http://localhost:4200/
  static baseUrl: string = Configurations.local
    ? "https://documentale.q8oilsitalia.it/"
    : Configurations.published
    ? "https://agenti.q8oilsitalia.it/"
    : "https://documentale.q8oilsitalia.it/";
  static appBaseServiceUrl: string = Configurations.local
    ? "https://documentale.q8oilsitalia.it/services/"
    : Configurations.published
    ? "https://agenti.q8oilsitalia.it/services/"
    : "https://documentale.q8oilsitalia.it/services/";
  static rolWebBaseUrl: string = Configurations.local
    ? "https://documentale.q8oilsitalia.it/rolweb/"
    : Configurations.published
    ? "https://agenti.q8oilsitalia.it/rolweb/"
    : "https://documentale.q8oilsitalia.it/rolweb/";
  get rolWebUrl(): string {
    return "documentale.q8oilsitalia.it/rolweb/";
  }

  get apiBaseUrlDashboard(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/`
    ); //:43187/api/IncassiConq/
  }

  get apiBaseUrlClienti(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43185/" : "") +
      "api/ClientiConq/"
    );
  }

  get apiBaseUrlStampe(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/StampeConq/`
    ); //`:43187/api/BrogliacciConq/`
  }
  get apiBaseUrlBrogliacci(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/BrogliacciConq/`
    ); //`:43187/api/BrogliacciConq/`
  }
  get apiBaseUrlPartite(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/PartiteConq/`
    ); //:43187/api/PartiteConq/
  }
  get apiBaseUrlIncassi(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/IncassiConq/`
    ); //:43187/api/IncassiConq/
  }
  get apiBaseUrlIncassiDettaglio(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/DettaglioIncassiConq/`
    ); //:43187/api/DettaglioIncassiConq/
  }
  get apiBaseUrlTipiAssegni(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/TipiAssegniConq/`
    ); //:43187/api/TipiAssegniConq/
  }
  get apiBaseUrlStatiBrogliacci(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/StatiBrogliacciConq/`
    ); //:43187/api/StatiBrogliacciConq/
  }
  get apiBaseUrlTagliMoneta(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43189/" : "") +
      `api/TaglioMonetaConq/`
    );
    //:43189/api/TaglioMonetaConq/
  }
  get apiBaseUrlDistinteVersamento(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/DistinteVersamentiConq/`
    );
    //43187/api/DistinteVersamentiConq/
  }
  get apiBaseUrlStatiDistinte(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/StatiDistinteConq/`
    ); //:43187
  }
  get apiBaseUrlDistinteIncassi(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/DistinteIncassiConq/`
    ); //:43187
  }

  get apiBaseUrlUsers(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/utenticonq/`
    ); //:43187
  }

  get apiBaseUrlZone(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/ZonePersoneConq/`
    ); //:43187
  }

  get apiBaseUrlUtilities(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/UtilitaConq/`
    ); //:43187
  }

  get apiBaseUrlUltimaVersioneApplicativo(): string {
    return (
      Configurations.appBaseServiceUrl +
      (Configurations.debug ? ":43187/" : "") +
      `api/VersioneApplicativoClientTipo/`
    ); //:43187
  }

  get getWebApiDriverTipo(): number {
    return Configurations.webApiDriverTipo;
  }

  get getSubfolderTaxonomyTipo(): number {
    return Configurations.subfolderTaxonomyTipo;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/core/configurations.ts